import {CustomFieldDef, CustomFieldDefEntity} from "../../../model/custom-field-def";
import {makeEntitySelectors} from "../base-entity-store";

export interface CustomFieldDefSelectorProps {

}

const customFieldDefSelectors = makeEntitySelectors<
  CustomFieldDef,
  CustomFieldDefEntity,
  CustomFieldDefSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => CustomFieldDefEntity.from(value),
});

export const customFieldDefsSelector =
  (props?: CustomFieldDefSelectorProps) =>
    customFieldDefSelectors.listSelector(props);

export const customFieldDefSelector =
  () => customFieldDefSelectors.singleSelector();
